import {useQuery} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {components} from '@/lib/api-schema'

export type CiiuCode = components['schemas']['CiiuCodeRead']
export type RiskOption = components['schemas']['RiskClassificationRead']
type CiiuPage = components['schemas']['Page_CiiuCodeRead_']

export function useCiiuSearch(query: string) {
  return useQuery({
    queryKey: ['ciiu-codes', query],
    queryFn: async () => (await api.get<CiiuPage>('/ciiu-codes', {params: {search: query, page_size: 8}})).data,
    enabled: query.trim().length > 0,
    placeholderData: (previous) => previous,
  })
}

export function useRiskOptions(code: string | null) {
  return useQuery({
    queryKey: ['ciiu-risk-options', code],
    queryFn: async () => (await api.get<RiskOption[]>(`/ciiu-codes/${code}/risk-options`)).data,
    enabled: !!code,
  })
}
